import tenantData from '@data';
import { getUnifiedCreditsUsageProductColor } from './unifiedCreditsUsageProductLabels';

/**
 * Fill icon / colors for credits consumption summary when `tenantData.products` has no row
 * for a slug (e.g. signature-listing), so Usage Breakdown and donut charts stay aligned with `getListingActions`.
 */
export const enrichQuotaRowWithProductVisuals = (slug, productsHashEntry, { isUnifiedCreditsUsage } = {}) => {
  const fromHash = productsHashEntry || {};
  const fromActions = slug ? tenantData.getListingActions(slug) : null;
  const unifiedColor = isUnifiedCreditsUsage ? getUnifiedCreditsUsageProductColor(slug) : null;
  const iconColor =
    unifiedColor ??
    fromHash.iconColor ??
    fromActions?.iconColor ??
    fromActions?.iconProps?.color;

  return {
    icon: fromHash.icon ?? fromActions?.icon,
    iconColor,
    iconProps: {
      ...(fromActions?.iconProps ?? {}),
      ...(fromHash.iconProps ?? {}),
      ...(iconColor ? { color: iconColor } : {}),
    },
  };
};

/** Resolved color for legend / donut segments and the top gradient strip. */
export const getQuotaSummarySegmentColor = (slug, productsHash, { isUnifiedCreditsUsage } = {}) => {
  if (isUnifiedCreditsUsage) {
    const unifiedColor = getUnifiedCreditsUsageProductColor(slug);
    if (unifiedColor) return unifiedColor;
  }
  const h = slug ? productsHash[slug] : null;
  if (h?.iconColor) return h.iconColor;
  const actions = slug ? tenantData.getListingActions(slug) : null;
  return actions?.iconColor ?? actions?.iconProps?.color ?? null;
};
